import {configureStore} from '@reduxjs/toolkit';

// ---- import from local reducers ----
import authReducer from './slices/AuthSlice';
import accessReducer from './slices/AccessSlice';
import roleReducer from './slices/RoleSlice';
import moduleReducer from './slices/ModuleSlice';
import rolePermissionReducer from './slices/RolePermissionSlice';
import userReducer from './slices/UserSlice';
import positionReducer from './slices/PositionSlice';
import buildingReducer from './slices/BuildingSlice';
import controlDeviceReducer from './slices/ControlDeviceSlice';
import residentReducer from './slices/ResidentSlice';
import elevatorReducer from './slices/ElevatorSlice';
import floorReducer from './slices/FloorSlice';
import applyReducer from './slices/ApplySlice';
import elevCtrlHistoryReducer from './slices/ElevCtrlHistorySlice';
import controlCodeReducer from './slices/ControlCodeSlice';
import caseReducer from './slices/CaseSlice';
import messageReducer from './slices/MessageSlice';
import departmentReducer from './slices/DepartmentSlice';
import conditionReducer from './slices/ConditionSlice';
import customerReducer from './slices/CustomerSlice';
import employeeReducer from './slices/EmployeeSlice';
import satisfactionReducer from './slices/SatisfactionSlice';
const store = configureStore({
  reducer: {
    auth: authReducer,
    access: accessReducer,
    role: roleReducer,
    module: moduleReducer,
    rolePermission: rolePermissionReducer,
    user: userReducer,
    position: positionReducer,
    building: buildingReducer,
    controlDevice: controlDeviceReducer,
    resident: residentReducer,
    elevator: elevatorReducer,
    employee: employeeReducer,
    floor: floorReducer,
    apply: applyReducer,
    elevCtrlHistory: elevCtrlHistoryReducer,
    controlCode: controlCodeReducer,
    case: caseReducer,
    satisfaction: satisfactionReducer,
    message: messageReducer,
    department: departmentReducer,
    condition: conditionReducer,
    customer: customerReducer,
  },
});

export default store;
